import React, { useCallback, useState } from 'react';
import ChartColorsContext from 'contexts/ChartColorsContext';
import { ChartColors } from '../theme/tokens';

const ChartColorsProvider = ({
  colors = ChartColors,
  children,
}: {
  // The colours to hand out, in order; the chart colours by default
  colors?: string[];
  children: JSX.Element | JSX.Element[];
}) => {
  const [assignedColors, setAssignedColors] = useState<{
    [key: string]: string | undefined;
  }>({});

  const getChartColor = useCallback(
    (term: string): string => {
      const assignedColor = assignedColors[term];
      if (assignedColor !== undefined) {
        return assignedColor;
      }

      let nextColor = colors[0];
      setAssignedColors((current) => {
        if (Object.keys(current).length === 0) {
          return {
            ...current,
            [term]: nextColor,
          };
        }

        const nextColorIndex = Object.keys(current).length;
        nextColor = colors[nextColorIndex];
        return {
          ...current,
          [term]: nextColor,
        };
      });

      return nextColor;
    },
    [assignedColors, colors],
  );

  const getChartColorIndex = useCallback(
    (term: string): number | undefined => {
      const assignedColor = assignedColors[term];
      if (assignedColor !== undefined) {
        return colors.findIndex((c) => c === assignedColor);
      }
      return undefined;
    },
    [assignedColors, colors],
  );

  return (
    <ChartColorsContext.Provider
      value={{
        hasProvider: true,
        getChartColor,
        getChartColorIndex,
      }}
    >
      {children}
    </ChartColorsContext.Provider>
  );
};

export default ChartColorsProvider;
